// Слепки промежуточных итогов на конец раунда для модалки итогов раунда (см.
// RoundEndModal): текущий и предыдущий. По предыдущему модалка показывает,
// как игрок сдвинулся в таблице и сколько итоговых очков набрал за раунд.
// Только память клиента, на сервер не уходит (noServerSync у экшена): после
// перезагрузки страницы предыдущего слепка просто нет, и модалка показывает
// итоги раунда без сравнения
//
// Слепок: {round, startedAt, standings: [{id, coins, winPoints, finalWinPoints}]},
// standings отсортированы по месту (первый — лидер), startedAt — момент
// старта партии, по нему модалка отбрасывает слепки чужой партии

const initialState = {
  current: null,
  previous: null,
};

const roundStandingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'RECORD_ROUND_STANDINGS':
      return {
        current: action.payload,
        previous: state.current,
      };
    // Новая партия. LOAD_STATE слепки НЕ сбрасывает: им же приходит ресинк
    // посреди матча (возврат вкладки из фона, отклоненное устаревшее
    // действие), и сброс оставлял следующий раунд без сравнения с прошлым.
    // Слепки чужой партии после загрузки отсекает сверка startedAt в модалке
    case 'START_GAME':
      return initialState;
    default:
      return state;
  }
};

export default roundStandingsReducer;
